import React, { Component } from "react";
import { Button, DropdownButton, Glyphicon, MenuItem} from "react-bootstrap";
//import "../../css/modal/ModalSaveBlock.css";

export default class DropdownBlockCategories extends React.Component {

    constructor(props) {
        super(props);

        this.state = { category: this.props.category };
    }

    onSelect(event) {
        var id       = event[0];
        var category = event[1];

        this.setState({
            id:    id,
            category: category
        });

        this.props.getProgramDropdown(id, category); // update id in parent
    }

    render() {
        var title = this.state.category;

        return (
            <DropdownButton id        = "Category"
                            onSelect  = {(event) => this.onSelect(event)}
                            title     = {title}
                            style     = {{fontSize:18}}
                            className = "dropdownHomeCategories"
                        >
                    <MenuItem eventKey={["1", "Dashboard"]} className="" style={{fontSize:18}}>Dashboard</MenuItem>
                    <MenuItem eventKey={["2", "My Programs"]} className="" style={{fontSize:18}}>My Programs</MenuItem>
             </DropdownButton>
         );
     }

}



// WEBPACK FOOTER //
// ./src/components/dropdown/DropdownHome.js